export const queryPage = '/icps/system/sign/goodService/inStorage/querypage'
export const saveOrUpdate = '/icps/system/sign/goodService/inStorage/saveOneResord'